"use client";

import { AdUnit } from "./ad-unit";

type LeaderboardAdProps = {
  slot: string;
  className?: string;
};

export function LeaderboardAd({ slot, className }: LeaderboardAdProps) {
  return (
    <div className={`my-4 flex justify-center ${className ?? ""}`}>
      <AdUnit className="w-full max-w-5xl" format="horizontal" slot={slot} />
    </div>
  );
}
